import cn from 'clsx'

import { Text, type TextProps } from '@/components/Text/Text'

import css from './HelpSnippet.module.css'

export interface HelpSnippetProps extends TextProps {
    html?: string
}

/** An HTML snippet container. */
export function HelpSnippet({ html = '', className, ...rest }: HelpSnippetProps) {
    return (
        <Text
            {...rest}
            className={cn(css.helpSnippet, className)}
            // biome-ignore lint/security/noDangerouslySetInnerHtml: HTML for the snippet is sanitized earlier
            dangerouslySetInnerHTML={{ __html: html }}
        />
    )
}
